import { useCallback } from 'react';

import { useLanguage } from '../../contexts/language';

import styles from './style.module.css';

// The seven days of the selected day's week, Monday first, each coloured by
// how complete its record is — never by what it says: green complete, yellow
// partial, white no entry, a dashed outline for days still to come (which
// cannot be chosen). The colour is backed by each day's accessible name, so it
// never carries the meaning alone. Phones only; a desktop has the month chart.
export function WeekStrip({ days, selected, today, onSelect }) {
  const { text, language } = useLanguage();

  const onClick = useCallback(function({ currentTarget }) {
    onSelect(currentTarget.value);
  }, [ onSelect ]);

  const letter = new Intl.DateTimeFormat(language, { weekday: 'narrow', timeZone: 'UTC' });
  const long = new Intl.DateTimeFormat(language, { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });

  const cells = days.map(function({ date, completeness }) {
    const at = new Date(`${ date }T00:00:00Z`);
    const future = date > today;
    const classNames = [ styles.day, styles[ completeness ] ];
    let state = text.completeness[ completeness ];
    let current;

    if (future === true) {
      classNames.push(styles.future);
      state = text.notYet;
    }

    if (date === selected) {
      classNames.push(styles.selected);
      current = 'date';
    }

    return (
      <button
        key={ date }
        type='button'
        className={ classNames.join(' ') }
        value={ date }
        disabled={ future }
        aria-current={ current }
        aria-label={ `${ long.format(at) }: ${ state }` }
        onClick={ onClick }
      >
        <span className={ styles.letter }>{ letter.format(at) }</span>

        <span className={ styles.number }>{ at.getUTCDate() }</span>
      </button>
    );
  });

  return <div className={ styles.strip }>{ cells }</div>;
}
